import { useAuth0 } from "@auth0/auth0-react";

function UnauthorizedAccess() {
  const { logout } = useAuth0();

  const handleLogout = () => {
    localStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <div className="min-h-screen bg-[#191919] text-white flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-blackishV2 border border-greyishV2 border-opacity-50 rounded-3xl p-8 text-center">
        <p className="text-2xl font-semibold mb-3">You are not authorised to login</p>
        <p className="text-sm text-greyish mb-6">
          Your account does not have access to this CMS portal. Please contact the Super Admin
          if you need access.
        </p>
        <button
          type="button"
          className="text-yellowish border border-yellowish bg-blackish px-6 py-2 rounded-xl text-[13px]"
          onClick={handleLogout}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
}

export default UnauthorizedAccess;
